import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { UpsertAction } from "../actions/UpsertAction";
import { UpsertFlow } from "../flows/UpserFlow";
import { Backdrop, CircularProgress } from "@mui/material";
import { UpsertGroups } from "../groups/UpsertGroups";

const BootstrapDialog = styled(Dialog)<{ dialogwidth: string }>(({ theme, dialogwidth }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: dialogwidth,
    maxWidth: '100%',
    overflowX: 'hidden'
  },
}));

export const 
CommonDialog = ({
  isOpen,
  actionType,
  title,
  dataToSet,
  handleClose,
  dialogwidth = '500px',
}: {
  isOpen: boolean;
  title: string;
  actionType: string;
  dataToSet?: any;
  handleClose: (isSubmitted: boolean) => void;
  dialogwidth?: string;
  dropdownList?:any[];
}) => {
  const [isResetForm, setIsResetForm] = React.useState<boolean>(false);
  const [isSubmitForm, setIsSubmitForm] = React.useState<boolean>(false);
  const [isInvalidForm, setIsInvalidForm] = React.useState<boolean>(false);
  const [isLoader, setLoader] = React.useState<boolean>(false);

  const handleInvalidForm = (isValid: boolean) => {
    setIsResetForm(false);
    setIsSubmitForm(false);
    setIsInvalidForm(isValid);
  };

  const handleReset = () => {
    setIsResetForm(true);
    setIsInvalidForm(false); // Reset the validity state
  };

  const handleSubmit = () => {
    setIsSubmitForm(true);
  };

  const toggleLoader = (isLoading: boolean) => {
    setLoader(isLoading);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        scroll="paper"
        dialogwidth={dialogwidth}
      >
        <DialogTitle sx={{ m: 0, p: 2 ,zIndex: 99999}} id="customized-dialog-title">
          {title ?? "Upsert Modal"}
        <IconButton
          aria-label="close"
          onClick={() => handleClose(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {actionType === "upsertAction" ? (
            <UpsertAction
              isResetForm={isResetForm}
              isSubmitForm={isSubmitForm}
              setIsInvalidForm={handleInvalidForm}
              setFormSubmitted={handleClose}
              dataToSet={dataToSet}
              toggleLoader={toggleLoader}
            />
          ) : actionType === "upsertFlow" ? (
            <UpsertFlow
              isResetForm={isResetForm}
              isSubmitForm={isSubmitForm}
              setIsInvalidForm={handleInvalidForm}
              setFormSubmitted={handleClose}
              dataToSet={dataToSet}
            />
          ) : actionType === "upsertGroups" ? (
            <UpsertGroups
              isResetForm={isResetForm}
              isSubmitForm={isSubmitForm}
              setIsInvalidForm={handleInvalidForm}
              setFormSubmitted={handleClose}
              dataToSet={dataToSet}
                  />
          ): null}
        </DialogContent>
        <DialogActions sx={{zIndex: 99999}}>
          <Button variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
        {isLoader && (
          <Backdrop
            sx={{
              color: 'grey',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </BootstrapDialog>
    </React.Fragment>
  );
};
